// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1-haB","label":"Section_label__1AHJ1","contentWrap":"Section_contentWrap__31R2f","footer":"Section_footer__2MqdA","footerInner":"Section_footerInner__pjYxD"};